import { render } from "./TextBlock.vue?vue&type=template&id=8bb2854c&scoped=true&ts=true"
import script from "./TextBlock.vue?vue&type=script&lang=ts"
export * from "./TextBlock.vue?vue&type=script&lang=ts"

import "./TextBlock.vue?vue&type=style&index=0&id=8bb2854c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bb2854c"]])

export default __exports__